import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import qs from 'qs';
import Component from "@reactions/component";
import { Pane, Dialog, SideSheet, Position } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Login from '../common/login';
import * as XLSX from 'xlsx';

const cookies = new Cookies();
const role = Number(localStorage.getItem('role'));

// ============================================
// STYLES
// ============================================
const styles = {
    container: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
        padding: '24px',
        fontFamily: "'Tajawal', 'Segoe UI', sans-serif",
        direction: 'rtl',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        flexWrap: 'wrap',
        gap: '16px',
    },
    headerRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '42px',
        height: '42px',
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        color: '#64748b',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        textDecoration: 'none',
    },
    pageTitle: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#1e293b',
        margin: 0,
    },
    headerActions: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
    },
    primaryButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        border: 'none',
        borderRadius: '10px',
        padding: '12px 20px',
        color: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 8px rgba(59, 130, 246, 0.3)',
    },
    successButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        border: 'none',
        borderRadius: '10px',
        padding: '12px 20px',
        color: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
    },
    // Stats Cards
    statsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '16px',
        marginBottom: '24px',
    },
    statCard: {
        background: '#fff',
        borderRadius: '12px',
        padding: '16px 20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        border: '1px solid #e2e8f0',
    },
    statValue: {
        fontSize: '28px',
        fontWeight: '700',
        marginBottom: '4px',
    },
    statLabel: {
        fontSize: '13px',
        color: '#64748b',
        fontWeight: '500',
    },
    // Filter & Sort Section
    filterSection: {
        background: '#fff',
        borderRadius: '12px',
        padding: '16px 20px',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        border: '1px solid #e2e8f0',
    },
    filterRow: {
        display: 'flex',
        gap: '16px',
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    filterGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        minWidth: '150px',
    },
    filterLabel: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#64748b',
    },
    filterSelect: {
        padding: '10px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#1e293b',
        background: '#fff',
        cursor: 'pointer',
        outline: 'none',
    },
    filterInput: {
        padding: '10px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#1e293b',
        outline: 'none',
        width: '200px',
    },
    filterButton: {
        padding: '10px 20px',
        background: '#3b82f6',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        marginTop: '22px',
    },
    resetButton: {
        padding: '10px 20px',
        background: '#fff',
        color: '#64748b',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        marginTop: '22px',
    },
    // Table
    tableContainer: {
        background: '#fff',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        border: '1px solid #e2e8f0',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
    },
    th: {
        padding: '14px 16px',
        textAlign: 'right',
        fontSize: '12px',
        fontWeight: '600',
        color: '#64748b',
        background: '#f8fafc',
        borderBottom: '1px solid #e2e8f0',
        cursor: 'pointer',
        userSelect: 'none',
        whiteSpace: 'nowrap',
    },
    thSortable: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        justifyContent: 'flex-start',
    },
    tr: {
        borderBottom: '1px solid #f1f5f9',
        transition: 'background 0.2s ease',
    },
    td: {
        padding: '12px 16px',
        fontSize: '14px',
        color: '#334155',
    },
    productImage: {
        width: '45px',
        height: '45px',
        borderRadius: '8px',
        objectFit: 'cover',
        border: '1px solid #e2e8f0',
        cursor: 'pointer',
    },
    badge: {
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '600',
    },
    badgeProduct: {
        background: '#dbeafe',
        color: '#2563eb',
    },
    badgePhone: {
        background: '#fef3c7',
        color: '#d97706',
    },
    actionButton: {
        padding: '6px 10px',
        borderRadius: '6px',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        marginLeft: '6px',
    },
    // Pagination
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        padding: '16px',
        background: '#f8fafc',
        borderTop: '1px solid #e2e8f0',
    },
    pageButton: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
        background: '#fff',
        color: '#64748b',
        fontSize: '13px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
    },
    pageButtonActive: {
        background: '#3b82f6',
        color: '#fff',
        border: '1px solid #3b82f6',
    },
    pageInfo: {
        color: '#64748b',
        fontSize: '13px',
        margin: '0 12px',
    },
    // Loading & Empty
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '60px',
    },
    spinner: {
        width: '40px',
        height: '40px',
        border: '3px solid #e2e8f0',
        borderTop: '3px solid #3b82f6',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
    },
    emptyState: {
        textAlign: 'center',
        padding: '50px',
        color: '#94a3b8',
    },
    // Tabs
    tabsContainer: {
        display: 'flex',
        gap: '4px',
        marginBottom: '20px',
        background: '#f1f5f9',
        padding: '4px',
        borderRadius: '12px',
        width: 'fit-content',
    },
    tab: {
        padding: '10px 24px',
        borderRadius: '8px',
        border: 'none',
        background: 'transparent',
        color: '#64748b',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
    },
    tabActive: {
        background: '#fff',
        color: '#1e293b',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    // Export Dialog
    exportOptions: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        padding: '16px 0',
    },
    exportOption: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '14px 16px',
        background: '#f8fafc',
        borderRadius: '10px',
        cursor: 'pointer',
        border: '2px solid #e2e8f0',
        transition: 'all 0.2s ease',
    },
    exportOptionSelected: {
        borderColor: '#3b82f6',
        background: '#eff6ff',
    },
    radioCircle: {
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        border: '2px solid #cbd5e1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    radioCircleSelected: {
        borderColor: '#3b82f6',
        background: '#3b82f6',
    },
    // SideSheet
    sideSheetContent: {
        padding: '24px',
        direction: 'rtl',
    },
    formGroup: {
        marginBottom: '16px',
    },
    formLabel: {
        display: 'block',
        fontSize: '13px',
        fontWeight: '600',
        color: '#475569',
        marginBottom: '6px',
    },
    formInput: {
        width: '100%',
        padding: '12px 14px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        transition: 'border-color 0.2s ease',
    },
    formSelect: {
        width: '100%',
        padding: '12px 14px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        background: '#fff',
    },
    submitButton: {
        width: '100%',
        padding: '14px',
        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: '#fff',
        border: 'none',
        borderRadius: '10px',
        fontSize: '15px',
        fontWeight: '600',
        cursor: 'pointer',
        marginTop: '20px',
    },
};

// Global CSS
const globalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;600;700&display=swap');
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
    }
    
    .table-row:hover { background: #f8fafc !important; }
    .btn-hover:hover { transform: translateY(-2px); opacity: 0.9; }
    .back-btn:hover { background: #f1f5f9; color: #3b82f6; }
    .action-edit:hover { background: #eff6ff !important; }
    .action-delete:hover { background: #fef2f2 !important; }
    .action-add:hover { background: #f0fdf4 !important; }
    .page-btn:hover:not(.active) { background: #f1f5f9; }
    .sort-header:hover { background: #f1f5f9; }
    
    .form-input:focus {
        border-color: #3b82f6 !important;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
    
    .link-btn:hover {
        background: #fcd34d !important;
        transform: scale(1.05);
    }
    
    .ads-btn:hover {
        background: #fcd34d !important;
    }
    
    .sizes-btn:hover {
        background: #dbeafe !important;
    }
    
    .add-ad-btn:hover {
        opacity: 0.9 !important;
        transform: scale(1.02);
    }
    
    .platform-ad-btn:hover {
        opacity: 0.9 !important;
        transform: scale(1.02);
        box-shadow: 0 4px 12px rgba(124, 58, 237, 0.4) !important;
    }
    
    /* Responsive Styles */
    @media (max-width: 1024px) {
        .filter-row {
            flex-direction: column !important;
            align-items: stretch !important;
        }
        
        .filter-group {
            width: 100% !important;
            min-width: unset !important;
        }
        
        .filter-input {
            width: 100% !important;
        }
    }
    
    @media (max-width: 768px) {
        .page-container {
            padding: 12px !important;
        }
        
        .header-section {
            flex-direction: column !important;
            gap: 12px !important;
            align-items: stretch !important;
        }
        
        .header-actions {
            width: 100% !important;
            justify-content: center !important;
        }
        
        .stats-container {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 8px !important;
        }
        
        .stat-card {
            padding: 12px 8px !important;
        }
        
        .stat-value {
            font-size: 20px !important;
        }
        
        .tabs-container {
            width: 100% !important;
        }
        
        .tab-btn {
            flex: 1 !important;
            padding: 8px 12px !important;
            font-size: 13px !important;
        }
        
        /* Hide table on mobile, show cards */
        .desktop-table {
            display: none !important;
        }
        
        .mobile-cards {
            display: flex !important;
        }
        
        .table-container {
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
            padding: 0 !important;
        }
        
        .filter-section {
            padding: 12px !important;
        }
        
        .filter-row {
            gap: 10px !important;
        }
        
        .filter-btn {
            padding: 10px 16px !important;
            font-size: 13px !important;
            margin-top: 0 !important;
        }
    }
    
    @media (min-width: 769px) {
        .mobile-cards {
            display: none !important;
        }
        
        .desktop-table {
            display: block !important;
        }
    }
    
    @media (max-width: 480px) {
        .stats-container {
            grid-template-columns: 1fr !important;
        }
        
        .header-actions {
            flex-direction: column !important;
        }
        
        .header-actions button {
            width: 100% !important;
            justify-content: center !important;
        }
        
        .page-title {
            font-size: 18px !important;
        }
        
        .pagination-container {
            flex-wrap: wrap !important;
            gap: 4px !important;
        }
        
        .page-btn {
            width: 32px !important;
            height: 32px !important;
            font-size: 12px !important;
        }
    }
`;

// ============================================
// ICONS
// ============================================
const Icons = {
    ArrowRight: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
    ),
    Plus: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
    ),
    Download: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
    ),
    Edit: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
    ),
    Delete: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
        </svg>
    ),
    Image: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
        </svg>
    ),
    Campaign: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
        </svg>
    ),
    PlusOne: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
    ),
    SortAsc: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M5 12l7-7 7 7"/>
        </svg>
    ),
    SortDesc: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M19 12l-7 7-7-7"/>
        </svg>
    ),
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    ChevronLeft: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6"/>
        </svg>
    ),
    ChevronRight: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6"/>
        </svg>
    ),
    ChevronsLeft: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/>
        </svg>
    ),
    ChevronsRight: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/>
        </svg>
    ),
    Package: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5">
            <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/>
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
        </svg>
    ),
    Check: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    Store: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
    ),
    Sizes: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
            <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
        </svg>
    ),
    // ── جديد: أيقونة "إعلان عبر المنصة" — صاروخ يدل على إطلاق إعلان ──
    Rocket: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
            <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
        </svg>
    ),
};

// ============================================
// MAIN COMPONENT
// ============================================
class Category extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            allItems: [], // للتصدير
            ads: [], // الإعلانات
            loading: true,
            
            // Tabs
            activeTab: 'products', // products, ads
            
            // Pagination
            currentPage: 1,
            totalPages: 1,
            total: 0,
            limit: 20,
            
            // إحصائيات كل المنتجات
            allItemsStats: {
                totalProducts: 0,
                phonesValue: 0,    // قيمة مخزن الأجهزة
                homeValue: 0,     // قيمة مخزن المنزلية
            },
            
            // Filters & Sort
            searchQuery: '',
            filterType: 'all', // all, product, phone
            sortBy: 'id',
            sortOrder: 'DESC',
            
            // Export Options
            showExportDialog: false,
            exportType: 'filtered', // all, filtered
            
            // Item Ads Dialog
            showItemAdsDialog: false,
            selectedItemAds: [],
            selectedItemName: '',
            
            // Sizes Dialog
            showSizesDialog: false,
            selectedItemParts: [],
            
            // Add Ad Form
            showAddAdSheet: false,
            addAdLoading: false,
            newAd: {
                name: '',
                price: '',
                count: '',
                body: '',
                page_id: '',
                item_id: '',
            },
            adFiles: {
                file1: null,
                file2: null,
                file3: null,
                file4: null,
            },
            
            // Add Item Form
            showAddSheet: false,
            addLoading: false,
            newItem: {
                name: '',
                dw_price: '',
                price: '',
                barcode: '',
                is_phone: 'none',
                image: null,
            },
            
            // Pages for ads
            pages: [],
        };
    }

    componentDidMount() {
        // Inject styles
        const styleSheet = document.createElement("style");
        styleSheet.innerText = globalStyles;
        document.head.appendChild(styleSheet);
        
        this.fetchItems();
        this.fetchPages();
        this.fetchAds();
    }

    // ── helper: فتح صفحة إنشاء إعلان في منصة AdFlow ────────────
    // يفتح في تبويب جديد ويعبّئ ?id=<components.id> تلقائياً
    openPlatformAdCreate = (itemId) => {
        if (!itemId) return;
        const url = `https://ads.mizeej.app/create?id=${itemId}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    fetchPages = () => {
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.get(host + `users/pages/name/all`, { headers: header })
            .then(res => this.setState({ pages: res.data.data?.pages || [] }))
            .catch(error => console.log(error));
    }

    fetchItems = () => {
        this.setState({ loading: true });
        
        const { currentPage, limit, searchQuery, filterType, sortBy, sortOrder } = this.state;
        const categoryId = this.props.match.params.id;
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };

        // Build query params
        let url = `${host}dashbord/component/${categoryId}?page=${currentPage}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
        
        if (searchQuery) url += `&search=${encodeURIComponent(searchQuery)}`;
        if (filterType !== 'all') url += `&is_phone=${filterType === 'phone' ? 1 : 0}`;

        axios.get(url, { headers: header })
            .then(res => {
                const data = res.data.data || res.data;
                this.setState({
                    items: data.items || [],
                    total: data.pagination?.total || data.items?.length || 0,
                    totalPages: data.pagination?.totalPages || 1,
                    loading: false,
                    // الإحصائيات من الـ Backend
                    allItemsStats: data.stats || {
                        totalProducts: 0,
                        phonesValue: 0,
                        homeValue: 0,
                    },
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
                toast.error('حدث خطأ في جلب البيانات');
            });
    }

    // جلب كل المنتجات للتصدير
    fetchAllItemsForExport = (callback) => {
        const categoryId = this.props.match.params.id;
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        
        axios.get(`${host}dashbord/component/${categoryId}?limit=10000`, { headers: header })
            .then(res => {
                const data = res.data.data || res.data;
                callback(data.items || []);
            })
            .catch(error => {
                console.log(error);
                toast.error('حدث خطأ في جلب البيانات');
            });
    }

    // جلب الإعلانات
    fetchAds = () => {
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        
        axios.get(host + `dashbord/shopall_/items`, { headers: header })
            .then(res => {
                this.setState({ ads: res.data.items || [] });
            })
            .catch(error => console.log(error));
    }

    // إضافة إعلان جديد
    handleAddAd = () => {
        const { newAd, adFiles } = this.state;
        
        if (!newAd.name || !newAd.price || !newAd.count || !newAd.item_id) {
            toast.error('يرجى ملء جميع الحقول المطلوبة');
            return;
        }

        if (!newAd.page_id || newAd.page_id === 'All') {
            toast.error('يرجى اختيار صفحة');
            return;
        }

        this.setState({ addAdLoading: true });
        
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        
        let formData = new FormData();
        formData.append("name", newAd.name);
        formData.append("item_id", newAd.item_id);
        formData.append("price", newAd.price);
        formData.append("count", newAd.count);
        formData.append("body", newAd.body || '');
        formData.append("page_id", newAd.page_id);
        
        // إضافة الصور
        if (adFiles.file1) formData.append("file", adFiles.file1);


        axios.post(host + 'dashbord/shop/items/add', formData, { headers: header })
            .then(res => {
                toast.success('تم إضافة الإعلان بنجاح');
                this.setState({
                    showAddAdSheet: false,
                    addAdLoading: false,
                    newAd: { name: '', price: '', count: '', body: '', page_id: '', item_id: '' },
                    adFiles: { file1: null, file2: null, file3: null, file4: null },
                });
                this.fetchAds();
            })
            .catch(error => {
                console.log(error);
                toast.error('حدث خطأ في إضافة الإعلان');
                this.setState({ addAdLoading: false });
            });
    }

    // تصدير Excel
    exportToExcel = (exportAll = false) => {
        const doExport = (dataToExport) => {
            if (dataToExport.length === 0) {
                toast.warning('لا توجد منتجات للتصدير');
                return;
            }

            const exportData = dataToExport.map(item => ({
                'رقم المنتج': item.id,
                'اسم المنتج': item.name,
                'العدد': item.count,
                'النوع': item.is_phone === 1 ? 'موبايل' : 'منتج',
            }));

            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'المنتجات');
            
            // تعيين عرض الأعمدة
            worksheet['!cols'] = [
                { wch: 12 }, // رقم المنتج
                { wch: 35 }, // اسم المنتج
                { wch: 10 }, // العدد
                { wch: 12 }, // النوع
            ];

            const fileName = exportAll 
                ? `all_products_${new Date().toISOString().split('T')[0]}.xlsx`
                : `filtered_products_${new Date().toISOString().split('T')[0]}.xlsx`;

            XLSX.writeFile(workbook, fileName);
            toast.success('تم تصدير الملف بنجاح');
            this.setState({ showExportDialog: false });
        };

        if (exportAll) {
            // جلب كل المنتجات ثم التصدير
            this.fetchAllItemsForExport(doExport);
        } else {
            // تصدير المنتجات المفلترة الحالية
            doExport(this.state.items);
        }
    }

    // Sorting
    handleSort = (field) => {
        const { sortBy, sortOrder } = this.state;
        const newOrder = sortBy === field && sortOrder === 'ASC' ? 'DESC' : 'ASC';
        this.setState({ sortBy: field, sortOrder: newOrder, currentPage: 1 }, this.fetchItems);
    }

    // Pagination
    handlePageChange = (page) => {
        this.setState({ currentPage: page }, this.fetchItems);
    }

    // Search & Filter
    handleSearch = () => {
        this.setState({ currentPage: 1 }, this.fetchItems);
    }

    handleReset = () => {
        this.setState({
            searchQuery: '',
            filterType: 'all',
            sortBy: 'id',
            sortOrder: 'DESC',
            currentPage: 1,
        }, this.fetchItems);
    }

    // Add Item
    handleAddItem = () => {
        const { newItem } = this.state;
        const categoryId = this.props.match.params.id;

        if (!newItem.name) {
            toast.error('يرجى إدخال اسم المنتج');
            return;
        }
        if (newItem.is_phone === 'none') {
            toast.error('يرجى اختيار نوع المنتج');
            return;
        }

        this.setState({ addLoading: true });

        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        const formData = new FormData();
        formData.append("name", newItem.name);
        formData.append("count", 0);
        formData.append("price", newItem.price || 0);
        formData.append("dw_price", newItem.dw_price || 0);
        formData.append("barcode", newItem.barcode || "");
        formData.append("is_phone", newItem.is_phone);
        formData.append("hasCount", true);
        formData.append("category_id", categoryId);
        if (newItem.image) formData.append("file", newItem.image);

        axios.post(host + `dashbord/component/add/`, formData, { headers: header })
            .then(() => {
                toast.success('تم إضافة المنتج بنجاح');
                this.setState({
                    showAddSheet: false,
                    addLoading: false,
                    newItem: { name: '', dw_price: '', price: '', barcode: '', is_phone: 'none', image: null },
                });
                this.fetchItems();
            })
            .catch(error => {
                console.log(error);
                toast.error('حدث خطأ في إضافة المنتج');
                this.setState({ addLoading: false });
            });
    }

    // Add Count
    handleAddCount = () => {
        const { selectedItemId, addCountValue } = this.state;
        
        if (!addCountValue || addCountValue < 1) {
            toast.error('يرجى إدخال عدد صحيح');
            return;
        }

        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        
        axios.put(host + `dashbord/components/count/${selectedItemId}`,
            qs.stringify({ count: addCountValue, price: 0, name: "0" }),
            { headers: header }
        )
        .then(() => {
            toast.success('تم إضافة العدد بنجاح');
            this.setState({ showAddCountDialog: false, addCountValue: '', selectedItemId: null });
            this.fetchItems();
        })
        .catch(error => {
            console.log(error);
            toast.error('حدث خطأ');
        });
    }

    // Delete Item
    handleDelete = () => {
        const { deleteItemId } = this.state;
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };

        axios.delete(host + `dashbord/component/${deleteItemId}`, { headers: header })
            .then(() => {
                toast.success('تم الحذف بنجاح');
                this.setState({ showDeleteDialog: false, deleteItemId: null });
                this.fetchItems();
            })
            .catch(error => {
                console.log(error);
                toast.error('حدث خطأ في الحذف');
            });
    }

    // Render Sort Icon
    renderSortIcon = (field) => {
        const { sortBy, sortOrder } = this.state;
        if (sortBy !== field) return null;
        return sortOrder === 'ASC' ? <Icons.SortAsc /> : <Icons.SortDesc />;
    }

    // Render Ads Table
    renderAdsTable = () => {
        const { ads, loading } = this.state;

        if (loading) {
            return (
                <div style={styles.loadingContainer}>
                    <div style={styles.spinner}></div>
                </div>
            );
        }

        if (ads.length === 0) {
            return (
                <div style={styles.emptyState}>
                    <Icons.Store />
                    <h3 style={{ color: '#64748b', margin: '16px 0 8px' }}>لا توجد إعلانات</h3>
                    <p>لم يتم العثور على إعلانات</p>
                </div>
            );
        }

        return (
            <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={{ ...styles.th, width: '80px', textAlign: 'center' }}>#</th>
                        <th style={{ ...styles.th, minWidth: '180px' }}>اسم المنتج</th>
                        <th style={{ ...styles.th, width: '100px', textAlign: 'center' }}>عدد القطع</th>
                        <th style={{ ...styles.th, width: '140px', textAlign: 'center' }}>السعر</th>
                        <th style={{ ...styles.th, width: '100px', textAlign: 'center' }}>item_id</th>
                        <th style={{ ...styles.th, width: '100px', textAlign: 'center' }}>الرابط</th>
                    </tr>
                </thead>
                <tbody>
                    {ads.map((item, idx) => (
                        <tr key={item.id} style={{ ...styles.tr, animation: `fadeIn 0.3s ease ${idx * 0.03}s both` }} className="table-row">
                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                <span style={{ fontWeight: '600', color: '#3b82f6' }}>#{item.id}</span>
                            </td>
                            <td style={styles.td}>
                                <span style={{ fontWeight: '500' }}>{item.name}</span>
                            </td>
                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                <span style={{
                                    display: 'inline-block',
                                    padding: '4px 12px',
                                    borderRadius: '8px',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    background: '#f0fdf4',
                                    color: '#10b981',
                                }}>
                                    {item.count}
                                </span>
                            </td>
                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                <span style={{ fontWeight: '600', fontSize: '14px' }}>
                                    {item.price?.toLocaleString()}
                                </span>
                                <span style={{ color: '#94a3b8', fontSize: '11px', marginRight: '4px' }}>د.ع</span>
                            </td>
                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                <span style={{ 
                                    color: '#64748b', 
                                    fontWeight: '500',
                                    background: '#f1f5f9',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    fontSize: '13px',
                                }}>
                                    {item.item?.id || item.item_id || '-'}
                                </span>
                            </td>
                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                <button
                                    style={{ 
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '36px',
                                        height: '36px',
                                        background: '#fef3c7', 
                                        color: '#d97706',
                                        border: '1px solid #fcd34d',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                    }}
                                    className="link-btn"
                                    onClick={() => window.open(`https://gra-jumla.com/index.html?item=${item.id}`, '_blank')}
                                    title="فتح الرابط"
                                >
                                    <Icons.Store />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    // Render Pagination
    renderPagination = () => {
        const { currentPage, totalPages, total, limit } = this.state;
        if (totalPages <= 1) return null;

        const pages = [];
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + 4);
        if (end - start < 4) start = Math.max(1, end - 4);

        for (let i = start; i <= end; i++) pages.push(i);

        return (
            <div style={styles.paginationContainer} className="pagination-container">
                <button style={styles.pageButton} className="page-btn" onClick={() => this.handlePageChange(1)} disabled={currentPage === 1}>
                    <Icons.ChevronsRight />
                </button>
                <button style={styles.pageButton} className="page-btn" onClick={() => this.handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                    <Icons.ChevronRight />
                </button>

                {start > 1 && <span style={styles.pageInfo}>...</span>}

                {pages.map(p => (
                    <button
                        key={p}
                        style={{ ...styles.pageButton, ...(p === currentPage ? styles.pageButtonActive : {}) }}
                        className={`page-btn ${p === currentPage ? 'active' : ''}`}
                        onClick={() => this.handlePageChange(p)}
                    >
                        {p}
                    </button>
                ))}

                {end < totalPages && <span style={styles.pageInfo}>...</span>}

                <button style={styles.pageButton} className="page-btn" onClick={() => this.handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    <Icons.ChevronLeft />
                </button>
                <button style={styles.pageButton} className="page-btn" onClick={() => this.handlePageChange(totalPages)} disabled={currentPage === totalPages}>
                    <Icons.ChevronsLeft />
                </button>

                <span style={styles.pageInfo}>
                    {((currentPage - 1) * limit) + 1} - {Math.min(currentPage * limit, total)} من {total}
                </span>
            </div>
        );
    }

    // Render Mobile Cards
    renderMobileCards = () => {
        const { items, loading, ads } = this.state;

        if (loading) {
            return (
                <div style={styles.loadingContainer}>
                    <div style={styles.spinner}></div>
                </div>
            );
        }

        if (items.length === 0) {
            return (
                <div style={styles.emptyState}>
                    <Icons.Package />
                    <h3 style={{ color: '#64748b', margin: '16px 0 8px' }}>لا توجد منتجات</h3>
                    <p>لم يتم العثور على منتجات مطابقة</p>
                </div>
            );
        }

        const getItemAds = (itemId) => {
            return ads.filter(ad => ad.item?.id === itemId || ad.item_id === itemId);
        };

        const getTotalCount = (item) => {
            if (item.part && item.part.length > 0) {
                return item.part.reduce((sum, p) => sum + (p.count || 0), 0);
            }
            return item.count || 0;
        };

        return (
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '12px', 
                padding: '0',
                width: '100%',
            }}>
                {items.map((item, idx) => {
                    const itemAds = getItemAds(item.id);
                    const adsCount = itemAds.length;
                    const totalCount = getTotalCount(item);
                    const hasParts = item.part && item.part.length > 0;

                    return (
                        <div 
                            key={item.id} 
                            style={{
                                background: '#fff',
                                borderRadius: '12px',
                                padding: '14px',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                animation: `fadeIn 0.3s ease ${idx * 0.05}s both`,
                                width: '100%',
                                boxSizing: 'border-box',
                            }}
                        >
                            {/* Header */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '12px',
                                paddingBottom: '12px',
                                borderBottom: '1px solid #f1f5f9',
                            }}>
                                <span style={{ fontWeight: '700', color: '#3b82f6', fontSize: '14px' }}>
                                    #{item.id}
                                </span>
                                <span style={{ 
                                    ...styles.badge, 
                                    ...(item.is_phone === 1 ? styles.badgePhone : styles.badgeProduct),
                                    fontSize: '11px',
                                    padding: '3px 8px',
                                }}>
                                    {item.is_phone === 1 ? 'موبايل' : 'منتج'}
                                </span>
                            </div>

                            {/* Product Name */}
                            <div style={{ fontWeight: '600', fontSize: '15px', color: '#1e293b', marginBottom: '12px' }}>
                                {item.name}
                            </div>

                            {/* Details Grid */}
                            <div style={{ 
                                display: 'grid', 
                                gridTemplateColumns: role !== 2 ? '1fr 1fr' : '1fr', 
                                gap: '10px', 
                                marginBottom: '12px',
                                width: '100%',
                            }}>
                                {role !== 2 && (
                                    <div style={{ 
                                        background: '#f8fafc', 
                                        padding: '12px', 
                                        borderRadius: '10px',
                                        textAlign: 'center',
                                    }}>
                                        <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>سعر الشراء</div>
                                        <div style={{ fontWeight: '700', color: '#1e293b', fontSize: '15px' }}>
                                            {item.dw_price?.toLocaleString()}
                                            <span style={{ fontSize: '11px', color: '#94a3b8', marginRight: '3px' }}>د.ع</span>
                                        </div>
                                    </div>
                                )}
                                <div style={{ 
                                    background: totalCount < 5 ? '#fef2f2' : totalCount < 10 ? '#fefce8' : '#f0fdf4',
                                    padding: '12px', 
                                    borderRadius: '10px',
                                    textAlign: 'center',
                                }}>
                                    <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>العدد</div>
                                    <div style={{ 
                                        fontWeight: '700', 
                                        fontSize: '18px',
                                        color: totalCount < 5 ? '#ef4444' : totalCount < 10 ? '#eab308' : '#10b981',
                                    }}>
                                        {totalCount}
                                    </div>
                                </div>
                            </div>

                            {/* Actions */}
                            <div style={{ 
                                display: 'flex', 
                                gap: '10px', 
                                width: '100%',
                                flexWrap: 'wrap',
                            }}>
                                {hasParts && (
                                    <button
                                        style={{
                                            flex: 1,
                                            minWidth: '45%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '6px',
                                            padding: '12px',
                                            background: '#eff6ff',
                                            color: '#2563eb',
                                            border: '1px solid #bfdbfe',
                                            borderRadius: '10px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => this.setState({ 
                                            showSizesDialog: true, 
                                            selectedItemParts: item.part,
                                            selectedItemName: item.name 
                                        })}
                                    >
                                        <Icons.Sizes />
                                        {item.part.length} مقاس
                                    </button>
                                )}
                                {adsCount > 0 && (
                                    <button
                                        style={{
                                            flex: 1,
                                            minWidth: '45%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '6px',
                                            padding: '12px',
                                            background: '#fef3c7',
                                            color: '#d97706',
                                            border: '1px solid #fcd34d',
                                            borderRadius: '10px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => this.setState({ 
                                            showItemAdsDialog: true, 
                                            selectedItemAds: itemAds,
                                            selectedItemName: item.name 
                                        })}
                                    >
                                        <Icons.Campaign />
                                        {adsCount} إعلان
                                    </button>
                                )}
                                {role !== 2 && (
                                    <button
                                        style={{
                                            flex: 1,
                                            minWidth: '45%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '6px',
                                            padding: '12px',
                                            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '10px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => this.setState({ 
                                            showAddAdSheet: true, 
                                            newAd: { 
                                                name: item.name, 
                                                price: '', 
                                                count: '', 
                                                body: '',
                                                page_id: '',
                                                item_id: item.id 
                                            },
                                            adFiles: { file1: null, file2: null, file3: null, file4: null },
                                        })}
                                    >
                                        <Icons.Plus />
                                        إضافة إعلان
                                    </button>
                                )}
                                {/* ── جديد: إعلان عبر المنصة ────────────────────── */}
                                {role !== 2 && (
                                    <button
                                        style={{
                                            flex: 1,
                                            minWidth: '45%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '6px',
                                            padding: '12px',
                                            background: 'linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '10px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            boxShadow: '0 2px 8px rgba(124, 58, 237, 0.3)',
                                        }}
                                        className="platform-ad-btn"
                                        onClick={() => this.openPlatformAdCreate(item.id)}
                                        title={`فتح منصة AdFlow مع المنتج #${item.id}`}
                                    >
                                        <Icons.Rocket />
                                        إعلان عبر المنصة
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    // Render Table
    renderTable = () => {
        const { items, loading, ads } = this.state;

        if (loading) {
            return (
                <div style={styles.loadingContainer}>
                    <div style={styles.spinner}></div>
                </div>
            );
        }

        if (items.length === 0) {
            return (
                <div style={styles.emptyState}>
                    <Icons.Package />
                    <h3 style={{ color: '#64748b', margin: '16px 0 8px' }}>لا توجد منتجات</h3>
                    <p>لم يتم العثور على منتجات مطابقة</p>
                </div>
            );
        }

        // دالة للحصول على عدد الإعلانات لكل منتج
        const getAdsCount = (itemId) => {
            return ads.filter(ad => ad.item?.id === itemId || ad.item_id === itemId).length;
        };

        // دالة للحصول على إعلانات منتج معين
        const getItemAds = (itemId) => {
            return ads.filter(ad => ad.item?.id === itemId || ad.item_id === itemId);
        };

        // حساب إجمالي العدد لمنتج مع المقاسات
        const getTotalCount = (item) => {
            if (item.part && item.part.length > 0) {
                return item.part.reduce((sum, p) => sum + (p.count || 0), 0);
            }
            return item.count || 0;
        };

        return (
            <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={{ ...styles.th, width: '80px', textAlign: 'center' }} className="sort-header" onClick={() => this.handleSort('id')}>
                            <div style={{ ...styles.thSortable, justifyContent: 'center' }}># {this.renderSortIcon('id')}</div>
                        </th>
                        <th style={{ ...styles.th, minWidth: '200px' }} className="sort-header" onClick={() => this.handleSort('name')}>
                            <div style={styles.thSortable}>اسم المنتج {this.renderSortIcon('name')}</div>
                        </th>
                        <th style={{ ...styles.th, width: '100px', textAlign: 'center' }}>النوع</th>
                        {role !== 2 && (
                            <th style={{ ...styles.th, width: '140px', textAlign: 'center' }} className="sort-header" onClick={() => this.handleSort('dw_price')}>
                                <div style={{ ...styles.thSortable, justifyContent: 'center' }}>سعر الشراء {this.renderSortIcon('dw_price')}</div>
                            </th>
                        )}
                        <th style={{ ...styles.th, width: '100px', textAlign: 'center' }} className="sort-header" onClick={() => this.handleSort('count')}>
                            <div style={{ ...styles.thSortable, justifyContent: 'center' }}>العدد {this.renderSortIcon('count')}</div>
                        </th>
                        <th style={{ ...styles.th, width: '200px', textAlign: 'center' }}>المقاسات</th>
                        <th style={{ ...styles.th, width: '120px', textAlign: 'center' }}>الإعلانات</th>
                        {role !== 2 && (
                            <th style={{ ...styles.th, width: '120px', textAlign: 'center' }}>إضافة إعلان</th>
                        )}
                        {/* ── جديد: عمود "إعلان عبر المنصة" ──────────────── */}
                        {role !== 2 && (
                            <th style={{ ...styles.th, width: '160px', textAlign: 'center' }}>إعلان عبر المنصة</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, idx) => {
                        const itemAds = getItemAds(item.id);
                        const adsCount = itemAds.length;
                        const totalCount = getTotalCount(item);
                        const hasParts = item.part && item.part.length > 0;
                        
                        return (
                            <tr key={item.id} style={{ ...styles.tr, animation: `fadeIn 0.3s ease ${idx * 0.03}s both` }} className="table-row">
                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                    <span style={{ fontWeight: '600', color: '#3b82f6' }}>#{item.id}</span>
                                </td>
                                <td style={styles.td}>
                                    <span style={{ fontWeight: '500' }}>{item.name}</span>
                                </td>
                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                    <span style={{ ...styles.badge, ...(item.is_phone === 1 ? styles.badgePhone : styles.badgeProduct) }}>
                                        {item.is_phone === 1 ? 'موبايل' : 'منتج'}
                                    </span>
                                </td>
                                {role !== 2 && (
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{ fontWeight: '600', fontSize: '14px' }}>
                                            {item.dw_price?.toLocaleString()}
                                        </span>
                                        <span style={{ color: '#94a3b8', fontSize: '11px', marginRight: '4px' }}>د.ع</span>
                                    </td>
                                )}
                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                    <span style={{
                                        display: 'inline-block',
                                        padding: '4px 12px',
                                        borderRadius: '8px',
                                        fontWeight: '700',
                                        fontSize: '14px',
                                        background: totalCount < 5 ? '#fef2f2' : totalCount < 10 ? '#fefce8' : '#f0fdf4',
                                        color: totalCount < 5 ? '#ef4444' : totalCount < 10 ? '#eab308' : '#10b981',
                                    }}>
                                        {totalCount}
                                    </span>
                                </td>
                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                    {hasParts ? (
                                        <button
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                padding: '6px 12px',
                                                background: '#eff6ff',
                                                color: '#2563eb',
                                                border: '1px solid #bfdbfe',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                            }}
                                            className="sizes-btn"
                                            onClick={() => this.setState({ 
                                                showSizesDialog: true, 
                                                selectedItemParts: item.part,
                                                selectedItemName: item.name 
                                            })}
                                        >
                                            <Icons.Sizes />
                                            {item.part.length} مقاس
                                        </button>
                                    ) : (
                                        <span style={{ color: '#94a3b8', fontSize: '13px' }}>-</span>
                                    )}
                                </td>
                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                    {adsCount > 0 ? (
                                        <button
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                padding: '6px 12px',
                                                background: '#fef3c7',
                                                color: '#d97706',
                                                border: '1px solid #fcd34d',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                            }}
                                            className="ads-btn"
                                            onClick={() => this.setState({ 
                                                showItemAdsDialog: true, 
                                                selectedItemAds: itemAds,
                                                selectedItemName: item.name 
                                            })}
                                        >
                                            <Icons.Campaign />
                                            {adsCount} إعلان
                                        </button>
                                    ) : (
                                        <span style={{ color: '#94a3b8', fontSize: '13px' }}>لا يوجد</span>
                                    )}
                                </td>
                                {role !== 2 && (
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <button
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                padding: '6px 12px',
                                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                            }}
                                            className="add-ad-btn"
                                            onClick={() => this.setState({ 
                                                showAddAdSheet: true, 
                                                newAd: { 
                                                    name: item.name, 
                                                    price: '', 
                                                    count: '', 
                                                    body: '',
                                                    page_id: '',
                                                    item_id: item.id 
                                                },
                                                adFiles: { file1: null, file2: null, file3: null, file4: null },
                                            })}
                                        >
                                            <Icons.Plus />
                                            إعلان
                                        </button>
                                    </td>
                                )}
                                {/* ── جديد: زر "إعلان عبر المنصة" ────────────────── */}
                                {/* يفتح https://ads.mizeej.app/create?id=<components.id> في تبويب جديد */}
                                {role !== 2 && (
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <button
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                padding: '6px 14px',
                                                background: 'linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)',
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 6px rgba(124, 58, 237, 0.3)',
                                            }}
                                            className="platform-ad-btn"
                                            onClick={() => this.openPlatformAdCreate(item.id)}
                                            title={`فتح منصة AdFlow مع المنتج #${item.id}`}
                                        >
                                            <Icons.Rocket />
                                            AdFlow
                                        </button>
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    render() {
        if (!cookies.get("token")) return <Login />;

        const {
            items, total, searchQuery, filterType, showAddSheet, addLoading, newItem,
            showExportDialog, exportType, activeTab, ads,
            showItemAdsDialog, selectedItemAds, selectedItemName,
            showSizesDialog, selectedItemParts, allItemsStats,
            showAddAdSheet, addAdLoading, newAd, adFiles, pages,
        } = this.state;

        return (
            <Context.Consumer>
                {ctx => (
                    <div style={styles.container} className="page-container">
                        <ToastContainer position="bottom-left" rtl theme="light" />

                        {/* Header */}
                        <div style={styles.header} className="header-section">
                            <div style={styles.headerRight}>
                                <Link to='/Cate2' style={styles.backButton} className="back-btn">
                                    <Icons.ArrowRight />
                                </Link>
                                <h1 style={styles.pageTitle} className="page-title">إدارة المنتجات</h1>
                            </div>
                            
                            <div style={styles.headerActions} className="header-actions">
                                {/* Export Excel */}
                                <button 
                                    style={styles.successButton} 
                                    className="btn-hover" 
                                    onClick={() => this.setState({ showExportDialog: true })}
                                >
                                    <Icons.Download />
                                    تصدير Excel
                                </button>
                                
                                {/* Add Product */}
                                {role !== 2 && (
                                    <button style={styles.primaryButton} className="btn-hover" onClick={() => this.setState({ showAddSheet: true })}>
                                        <Icons.Plus />
                                        إضافة منتج
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Tabs */}
                        <div style={styles.tabsContainer} className="tabs-container">
                            <button 
                                style={{ ...styles.tab, ...(activeTab === 'products' ? styles.tabActive : {}) }}
                                className="tab-btn"
                                onClick={() => this.setState({ activeTab: 'products' })}
                            >
                                المنتجات ({total})
                            </button>
                            <button 
                                style={{ ...styles.tab, ...(activeTab === 'ads' ? styles.tabActive : {}) }}
                                className="tab-btn"
                                onClick={() => this.setState({ activeTab: 'ads' })}
                            >
                                الإعلانات ({ads.length})
                            </button>
                        </div>

                        {activeTab === 'products' && (
                            <>
                                {/* Stats - فقط للأدمن */}
                                {role === -1 && (
                                    <div style={styles.statsContainer} className="stats-container">
                                        <div style={styles.statCard} className="stat-card">
                                            <div style={{ ...styles.statValue, color: '#3b82f6' }} className="stat-value">
                                                {allItemsStats.totalProducts}
                                            </div>
                                            <div style={styles.statLabel}>عدد المنتجات</div>
                                        </div>
                                        <div style={styles.statCard} className="stat-card">
                                            <div style={{ ...styles.statValue, color: '#f59e0b', fontSize: '20px' }} className="stat-value">
                                                {allItemsStats.phonesValue?.toLocaleString()}
                                            </div>
                                            <div style={styles.statLabel}>قيمة مخزن الأجهزة</div>
                                        </div>
                                        <div style={styles.statCard} className="stat-card">
                                            <div style={{ ...styles.statValue, color: '#10b981', fontSize: '20px' }} className="stat-value">
                                                {allItemsStats.homeValue?.toLocaleString()}
                                            </div>
                                            <div style={styles.statLabel}>قيمة مخزن المنزلية</div>
                                        </div>
                                    </div>
                                )}

                                {/* Filters */}
                                <div style={styles.filterSection}>
                                    <div style={styles.filterRow} className="filter-row">
                                        <div style={styles.filterGroup} className="filter-group">
                                            <label style={styles.filterLabel}>البحث (الاسم أو ID)</label>
                                            <input
                                                type="text"
                                                style={styles.filterInput}
                                                className="filter-input"
                                                placeholder="اسم المنتج أو رقم ID..."
                                                value={searchQuery}
                                                onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                                onKeyPress={(e) => e.key === 'Enter' && this.handleSearch()}
                                            />
                                        </div>
                                        
                                        <div style={styles.filterGroup} className="filter-group">
                                            <label style={styles.filterLabel}>النوع</label>
                                            <select
                                                style={styles.filterSelect}
                                                value={filterType}
                                                onChange={(e) => this.setState({ filterType: e.target.value })}
                                            >
                                                <option value="all">الكل</option>
                                                <option value="product">منتجات</option>
                                                <option value="phone">موبايلات</option>
                                            </select>
                                        </div>

                                        <button style={styles.filterButton} onClick={this.handleSearch}>
                                            <Icons.Search /> بحث
                                        </button>
                                        <button style={styles.resetButton} onClick={this.handleReset}>
                                            <Icons.Refresh /> إعادة تعيين
                                        </button>
                                    </div>
                                </div>

                                {/* Table for Desktop */}
                                <div style={styles.tableContainer}>
                                    <div className="desktop-table">
                                        {this.renderTable()}
                                    </div>
                                <div className="mobile-cards" style={{ display: 'none', width: '100%' }}>
                                        {this.renderMobileCards()}
                                    </div>
                                    {this.renderPagination()}
                                </div>
                            </>
                        )}

                        {activeTab === 'ads' && (
                            <div style={styles.tableContainer}>
                                {this.renderAdsTable()}
                            </div>
                        )}

                        {/* Export Dialog */}
                        <Dialog
                            isShown={showExportDialog}
                            title="تصدير إلى Excel"
                            onCloseComplete={() => this.setState({ showExportDialog: false })}
                            confirmLabel="تصدير"
                            cancelLabel="إلغاء"
                            onConfirm={() => this.exportToExcel(exportType === 'all')}
                        >
                            <div style={{ direction: 'rtl' }}>
                                <p style={{ color: '#64748b', marginBottom: '16px' }}>اختر نوع التصدير:</p>
                                <div style={styles.exportOptions}>
                                    <div 
                                        style={{ 
                                            ...styles.exportOption, 
                                            ...(exportType === 'filtered' ? styles.exportOptionSelected : {}) 
                                        }}
                                        onClick={() => this.setState({ exportType: 'filtered' })}
                                    >
                                        <div style={{ 
                                            ...styles.radioCircle, 
                                            ...(exportType === 'filtered' ? styles.radioCircleSelected : {}) 
                                        }}>
                                            {exportType === 'filtered' && <Icons.Check />}
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: '600', color: '#1e293b' }}>المنتجات المفلترة</div>
                                            <div style={{ fontSize: '12px', color: '#64748b' }}>تصدير {items.length} منتج حسب الفلتر الحالي</div>
                                        </div>
                                    </div>
                                    
                                    <div 
                                        style={{ 
                                            ...styles.exportOption, 
                                            ...(exportType === 'all' ? styles.exportOptionSelected : {}) 
                                        }}
                                        onClick={() => this.setState({ exportType: 'all' })}
                                    >
                                        <div style={{ 
                                            ...styles.radioCircle, 
                                            ...(exportType === 'all' ? styles.radioCircleSelected : {}) 
                                        }}>
                                            {exportType === 'all' && <Icons.Check />}
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: '600', color: '#1e293b' }}>كل المنتجات</div>
                                            <div style={{ fontSize: '12px', color: '#64748b' }}>تصدير جميع المنتجات بدون فلتر</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        {/* Item Ads Dialog */}
                        <Dialog
                            isShown={showItemAdsDialog}
                            title={`إعلانات: ${selectedItemName}`}
                            onCloseComplete={() => this.setState({ showItemAdsDialog: false, selectedItemAds: [], selectedItemName: '' })}
                            hasFooter={false}
                            width={700}
                        >
                            <div style={{ direction: 'rtl', maxHeight: '400px', overflowY: 'auto' }}>
                                {selectedItemAds.length > 0 ? (
                                    <table style={{ ...styles.table, fontSize: '13px' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...styles.th, padding: '10px 12px', textAlign: 'center' }}>#</th>
                                                <th style={{ ...styles.th, padding: '10px 12px' }}>الاسم</th>
                                                <th style={{ ...styles.th, padding: '10px 12px', textAlign: 'center' }}>العدد</th>
                                                <th style={{ ...styles.th, padding: '10px 12px', textAlign: 'center' }}>السعر</th>
                                                <th style={{ ...styles.th, padding: '10px 12px', textAlign: 'center' }}>الرابط</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedItemAds.map((ad, idx) => (
                                                <tr key={ad.id} style={styles.tr} className="table-row">
                                                    <td style={{ ...styles.td, padding: '10px 12px', textAlign: 'center' }}>
                                                        <span style={{ fontWeight: '600', color: '#3b82f6' }}>#{ad.id}</span>
                                                    </td>
                                                    <td style={{ ...styles.td, padding: '10px 12px' }}>
                                                        {ad.name}
                                                    </td>
                                                    <td style={{ ...styles.td, padding: '10px 12px', textAlign: 'center' }}>
                                                        <span style={{
                                                            padding: '3px 10px',
                                                            borderRadius: '6px',
                                                            fontWeight: '600',
                                                            background: '#f0fdf4',
                                                            color: '#10b981',
                                                        }}>
                                                            {ad.count}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...styles.td, padding: '10px 12px', textAlign: 'center' }}>
                                                        <span style={{ fontWeight: '600' }}>{ad.price?.toLocaleString()}</span>
                                                        <span style={{ color: '#94a3b8', fontSize: '10px', marginRight: '3px' }}>د.ع</span>
                                                    </td>
                                                    <td style={{ ...styles.td, padding: '10px 12px', textAlign: 'center' }}>
                                                        <button
                                                            style={{
                                                                padding: '5px 10px',
                                                                background: '#fef3c7',
                                                                color: '#d97706',
                                                                border: '1px solid #fcd34d',
                                                                borderRadius: '6px',
                                                                cursor: 'pointer',
                                                                fontSize: '12px',
                                                            }}
                                                            onClick={() => window.open(`https://gra-jumla.com/index.html?item=${ad.id}`, '_blank')}
                                                        >
                                                            فتح
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p style={{ textAlign: 'center', color: '#94a3b8', padding: '20px' }}>لا توجد إعلانات</p>
                                )}
                            </div>
                        </Dialog>

                        {/* Sizes Dialog */}
                        <Dialog
                            isShown={showSizesDialog}
                            title={`مقاسات: ${selectedItemName}`}
                            onCloseComplete={() => this.setState({ showSizesDialog: false, selectedItemParts: [], selectedItemName: '' })}
                            hasFooter={false}
                            width={500}
                        >
                            <div style={{ direction: 'rtl', maxHeight: '400px', overflowY: 'auto' }}>
                                {selectedItemParts.length > 0 ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        {selectedItemParts.map((part, idx) => (
                                            <div 
                                                key={part.id || idx} 
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '12px 16px',
                                                    background: '#f8fafc',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e2e8f0',
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <span style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '32px',
                                                        height: '32px',
                                                        background: '#eff6ff',
                                                        color: '#2563eb',
                                                        borderRadius: '8px',
                                                        fontWeight: '700',
                                                        fontSize: '14px',
                                                    }}>
                                                        {idx + 1}
                                                    </span>
                                                    <span style={{ fontWeight: '600', color: '#1e293b', fontSize: '15px' }}>
                                                        {part.name || part.size || `مقاس ${idx + 1}`}
                                                    </span>
                                                </div>
                                                <span style={{
                                                    padding: '6px 14px',
                                                    borderRadius: '8px',
                                                    fontWeight: '700',
                                                    fontSize: '14px',
                                                    background: part.count < 5 ? '#fef2f2' : part.count < 10 ? '#fefce8' : '#f0fdf4',
                                                    color: part.count < 5 ? '#ef4444' : part.count < 10 ? '#eab308' : '#10b981',
                                                }}>
                                                    {part.count} قطعة
                                                </span>
                                            </div>
                                        ))}
                                        
                                        {/* الإجمالي */}
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '14px 16px',
                                            background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                            borderRadius: '10px',
                                            marginTop: '8px',
                                        }}>
                                            <span style={{ fontWeight: '600', color: '#fff', fontSize: '15px' }}>
                                                الإجمالي
                                            </span>
                                            <span style={{
                                                padding: '6px 14px',
                                                background: 'rgba(255,255,255,0.2)',
                                                borderRadius: '8px',
                                                fontWeight: '700',
                                                fontSize: '15px',
                                                color: '#fff',
                                            }}>
                                                {selectedItemParts.reduce((sum, p) => sum + (p.count || 0), 0)} قطعة
                                            </span>
                                        </div>
                                    </div>
                                ) : (
                                    <p style={{ textAlign: 'center', color: '#94a3b8', padding: '20px' }}>لا توجد مقاسات</p>
                                )}
                            </div>
                        </Dialog>

                        {/* Add Product SideSheet */}
                        <SideSheet
                            isShown={showAddSheet}
                            position={Position.LEFT}
                            onCloseComplete={() => this.setState({ showAddSheet: false })}
                        >
                            <div style={styles.sideSheetContent}>
                                <h2 style={{ marginBottom: '24px', color: '#1e293b' }}>إضافة منتج جديد</h2>
                                
                                <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>اسم المنتج</label>
                                    <input
                                        type="text"
                                        style={styles.formInput}
                                        className="form-input"
                                        placeholder="أدخل اسم المنتج"
                                        value={newItem.name}
                                        onChange={(e) => this.setState({ newItem: { ...newItem, name: e.target.value } })}
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>سعر الشراء</label>
                                    <input
                                        type="number"
                                        style={styles.formInput}
                                        className="form-input"
                                        placeholder="0"
                                        value={newItem.dw_price}
                                        onChange={(e) => this.setState({ newItem: { ...newItem, dw_price: e.target.value } })}
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>سعر البيع</label>
                                    <input
                                        type="number"
                                        style={styles.formInput}
                                        className="form-input"
                                        placeholder="0"
                                        value={newItem.price}
                                        onChange={(e) => this.setState({ newItem: { ...newItem, price: e.target.value } })}
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>الباركود</label>
                                    <input
                                        type="text"
                                        style={styles.formInput}
                                        className="form-input"
                                        placeholder="الباركود (اختياري)"
                                        value={newItem.barcode}
                                        onChange={(e) => this.setState({ newItem: { ...newItem, barcode: e.target.value } })}
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>نوع المنتج</label>
                                    <select
                                        style={styles.formSelect}
                                        value={newItem.is_phone}
                                        onChange={(e) => this.setState({ newItem: { ...newItem, is_phone: e.target.value } })}
                                    >
                                        <option value="none">اختر النوع</option>
                                        <option value="0">منتج عادي</option>
                                        <option value="1">موبايل</option>
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>الصورة</label>
                                    <input
                                        type="file"
                                        style={styles.formInput}
                                        accept="image/*"
                                        onChange={(e) => this.setState({ newItem: { ...newItem, image: e.target.files[0] } })}
                                    />
                                </div>

                                <button
                                    style={{ ...styles.submitButton, opacity: addLoading ? 0.7 : 1 }}
                                    onClick={this.handleAddItem}
                                    disabled={addLoading}
                                >
                                    {addLoading ? 'جاري الإضافة...' : 'إضافة المنتج'}
                                </button>
                            </div>
                        </SideSheet>

                        {/* Add Ad SideSheet */}
                        <SideSheet
                            isShown={showAddAdSheet}
                            position={Position.LEFT}
                            onCloseComplete={() => this.setState({ 
                                showAddAdSheet: false,
                                newAd: { name: '', price: '', count: '', body: '', page_id: '', item_id: '' },
                                adFiles: { file1: null, file2: null, file3: null, file4: null },
                            })}
                        >
                            <div style={{ padding: '0', direction: 'rtl', height: '100%', background: '#f8fafc' }}>
                                {/* Header */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                    padding: '24px',
                                    color: '#fff',
                                }}>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700' }}>
                                        إضافة إعلان جديد
                                    </h2>
                                    <p style={{ margin: '8px 0 0', opacity: 0.9, fontSize: '14px' }}>
                                        {newAd.name || 'اختر منتج'}
                                    </p>
                                </div>

                                {/* Form Content */}
                                <div style={{ padding: '20px', overflowY: 'auto', height: 'calc(100% - 180px)' }}>
                                    {/* Basic Info Card */}
                                    <div style={{
                                        background: '#fff',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        marginBottom: '16px',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                    }}>
                                        <h3 style={{ margin: '0 0 16px', fontSize: '15px', color: '#1e293b', fontWeight: '600' }}>
                                            المعلومات الأساسية
                                        </h3>
                                        
                                        <div style={{ marginBottom: '14px' }}>
                                            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>
                                                اسم المنتج
                                            </label>
                                            <input
                                                type="text"
                                                style={{
                                                    width: '100%',
                                                    padding: '12px 14px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '10px',
                                                    fontSize: '14px',
                                                    outline: 'none',
                                                    transition: 'border-color 0.2s',
                                                }}
                                                className="form-input"
                                                placeholder="أدخل اسم المنتج"
                                                value={newAd.name}
                                                onChange={(e) => this.setState({ newAd: { ...newAd, name: e.target.value } })}
                                            />
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
                                            <div>
                                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>
                                                    السعر
                                                </label>
                                                <input
                                                    type="number"
                                                    style={{
                                                        width: '100%',
                                                        padding: '12px 14px',
                                                        border: '2px solid #e2e8f0',
                                                        borderRadius: '10px',
                                                        fontSize: '14px',
                                                        outline: 'none',
                                                    }}
                                                    className="form-input"
                                                    placeholder="0"
                                                    value={newAd.price}
                                                    onChange={(e) => this.setState({ newAd: { ...newAd, price: e.target.value } })}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>
                                                    العدد
                                                </label>
                                                <input
                                                    type="number"
                                                    style={{
                                                        width: '100%',
                                                        padding: '12px 14px',
                                                        border: '2px solid #e2e8f0',
                                                        borderRadius: '10px',
                                                        fontSize: '14px',
                                                        outline: 'none',
                                                    }}
                                                    className="form-input"
                                                    placeholder="0"
                                                    value={newAd.count}
                                                    onChange={(e) => this.setState({ newAd: { ...newAd, count: e.target.value } })}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>
                                                الوصف
                                            </label>
                                            <textarea
                                                style={{
                                                    width: '100%',
                                                    padding: '12px 14px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '10px',
                                                    fontSize: '14px',
                                                    outline: 'none',
                                                    minHeight: '80px',
                                                    resize: 'vertical',
                                                    fontFamily: 'inherit',
                                                }}
                                                className="form-input"
                                                placeholder="أدخل وصف المنتج (اختياري)"
                                                value={newAd.body}
                                                onChange={(e) => this.setState({ newAd: { ...newAd, body: e.target.value } })}
                                            />
                                        </div>
                                    </div>

                                    {/* Page Selection Card */}
                                    <div style={{
                                        background: '#fff',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        marginBottom: '16px',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                    }}>
                                        <h3 style={{ margin: '0 0 16px', fontSize: '15px', color: '#1e293b', fontWeight: '600' }}>
                                            الصفحة
                                        </h3>
                                        
                                        <select
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                border: '2px solid #e2e8f0',
                                                borderRadius: '10px',
                                                fontSize: '14px',
                                                outline: 'none',
                                                background: '#fff',
                                                cursor: 'pointer',
                                            }}
                                            value={newAd.page_id}
                                            onChange={(e) => this.setState({ newAd: { ...newAd, page_id: e.target.value } })}
                                        >
                                            <option value="">اختر صفحة</option>
                                            {pages.map(page => (
                                                <option key={page.id} value={page.id}>
                                                    {page.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Images Card */}
                                    <div style={{
                                        background: '#fff',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                    }}>
                                        <h3 style={{ margin: '0 0 16px', fontSize: '15px', color: '#1e293b', fontWeight: '600' }}>
                                            الصور
                                        </h3>
                                        
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                            {[1, 2, 3, 4].map(num => (
                                                <div key={num} style={{
                                                    border: '2px dashed #e2e8f0',
                                                    borderRadius: '10px',
                                                    padding: '12px',
                                                    textAlign: 'center',
                                                    background: adFiles[`file${num}`] ? '#f0fdf4' : '#fafafa',
                                                    transition: 'all 0.2s',
                                                }}>
                                                    <label style={{ cursor: 'pointer', display: 'block' }}>
                                                        <input
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            accept="image/*"
                                                            onChange={(e) => this.setState({ 
                                                                adFiles: { ...adFiles, [`file${num}`]: e.target.files[0] } 
                                                            })}
                                                        />
                                                        <div style={{
                                                            width: '40px',
                                                            height: '40px',
                                                            margin: '0 auto 8px',
                                                            borderRadius: '50%',
                                                            background: adFiles[`file${num}`] ? '#10b981' : '#e2e8f0',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            color: adFiles[`file${num}`] ? '#fff' : '#94a3b8',
                                                        }}>
                                                            {adFiles[`file${num}`] ? '✓' : num}
                                                        </div>
                                                        <span style={{ 
                                                            fontSize: '12px', 
                                                            color: adFiles[`file${num}`] ? '#10b981' : '#64748b',
                                                            fontWeight: '500',
                                                        }}>
                                                            {adFiles[`file${num}`] ? 'تم الاختيار' : `صورة ${num}`}
                                                        </span>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* Footer Button */}
                                <div style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    padding: '16px 20px',
                                    background: '#fff',
                                    borderTop: '1px solid #e2e8f0',
                                }}>
                                    <button
                                        style={{
                                            width: '100%',
                                            padding: '14px',
                                            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '12px',
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            cursor: 'pointer',
                                            opacity: addAdLoading ? 0.7 : 1,
                                            transition: 'all 0.2s',
                                        }}
                                        onClick={this.handleAddAd}
                                        disabled={addAdLoading}
                                    >
                                        {addAdLoading ? 'جاري الإضافة...' : 'إضافة الإعلان'}
                                    </button>
                                </div>
                            </div>
                        </SideSheet>
                    </div>
                )}
            </Context.Consumer>
        );
    }
}

export default Category;